module.exports = __webpack_public_path__ + "img/parking.a6b107cd.svg";